import { Facebook, Github, Instagram, Link, Linkedin, Phone } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Typewriter } from 'react-simple-typewriter';

const Main = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const phone = "6387034769" ;

  const images = [
    {
      id: "1",
      src: "/headerimg1.jpeg"
    },
    {
      id: "2",
      src: "/headerimg2.jpeg"
    },
    {
      id: "3",
      src: "/headerimg3.jpeg"
    },
    {
      id: "4",
      src: "/headerimg4.jpeg"
    }
  ];

  // ✅ This useEffect runs every 5 seconds to update activeIndex
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 5000); // 5 seconds per image

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="main">
      <div className="image-slider">
        {images.map((img, i) => (
          <img
            key={img.id}
            height="100%"
            width="100%"
            src={img.src}
            alt={`slide-${i}`}
            className={`slider-img ${i === activeIndex ? "active" : ""}`}
          />
        ))}
      </div>
      <div className="myimage">
        <div className="img">
        <img src ="./profileimg.jpeg" alt="/" height="100%" width="100%" />
        </div>
      </div>
      <span className="name">Mohammad Ziya</span>
      <span className ="typewriter">
          <Typewriter
        words={['Full Stack Developer', 'Frontend Developer', 'Coder']}
        loop={true}
        cursor
        cursorStyle='|'
        typeSpeed={70}
        deleteSpeed={50}
        delaySpeed={1000}
      />
      </span>
      <div className="logos">
         <a href="https://www.instagram.com/ziya_mohammad_.123" target="_blank" rel="noreferrer"  ><Instagram  fill ="white" size="28px"/></a>
        <a href="https://www.github.com/ziyamohammad" target="_blank" rel="noreferrer"  ><Github  fill ="white" size="28px"/></a>
        <a href="https://www.linkedin.com/in/ziyamohammad/" target="_blank" rel="noreferrer"  ><Linkedin  fill ="white" size="28px"/></a>
      </div>
      <div className = "aboutbuttons">
        <a href="https://drive.google.com/file/d/1QuLq0krND_cZz4skGW9dmsRuv2I91h7d/view?usp=drivesdk" target="_blank" rel="noreferrer" className ="button1" >Download CV<Link fill="white" size="20px"/></a>
         <a href = {`tel:${phone}`} className ="button2">Contact me <Phone fill="white" size="20px"/></a>
      </div>
    </div>
  );
};

export default Main;
